module.exports = __webpack_public_path__ + "img/cordial.ae50335.jpg";